import React from "react";
import { Card, Radio, Typography } from "antd";

const { Text } = Typography;

type RecipientCardProps = {
  id?: string;
  name?: string;
  email?: string;
  isLocked?: boolean; // whether selection is disabled
  selectedId?: string; // currently selected recipient id
  handleSelect?: (id: string) => void; // on click handler
  reSend?: boolean;
};

const RecipientCard: React.FC<RecipientCardProps> = ({
  id,
  name,
  email,
  isLocked = false,
  selectedId,
  reSend = false,
  handleSelect,
}) => {
  const isSelected = selectedId === id;

  return (
    <Card
      key={id}
      className="send-signature-card"
      style={{
        cursor: isLocked ? "not-allowed" : "pointer",
        opacity: isLocked ? 0.5 : 1,
        borderRadius: 8,
        marginTop: reSend ? "10px" : "0px",
      }}
      bodyStyle={{ padding: "6px" }}
      onClick={() => !isLocked && handleSelect(id)}
    >
      <div style={{ display: "flex" }}>
        <Radio value={id} disabled={isLocked} checked={isSelected || reSend} style={{ marginTop: 12 }} />
        <div style={{ marginLeft: 6 }}>
          <Text strong>{name}</Text>
          <br />
          <Text type="secondary">{email}</Text>
        </div>
      </div>
    </Card>
  );
};

export default RecipientCard;
